import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import parseHtmlToReact from 'html-react-parser';
import { memo, useCallback, useMemo } from 'react';

import { useWindowSize } from '@hooks/useWindowSize';
import { useTranslateFn } from '@shared/Translate';
import { stripHtml } from '@utilities/dom';

import * as styles from './styles.module.scss';

export const Item = ({ stepClick, index, selected, enableCompetitionLink, item, itemWidth }) => {
  const t = useTranslateFn();
  const handleClick = useCallback(() => {
    stepClick(index);
  }, [index, stepClick]);

  const { isDesktop } = useWindowSize();

  const getCompetitionLink = () => {
    let url = `/api/v1/linkrules/competition/${item.classification.competition}`;
    url = item?.classification?.phase ? `${url}?phase=${item.classification.phase}` : url;
    return url;
  };

  const enableBottomLink = useMemo(() => {
    return (
      enableCompetitionLink &&
      (item?.classification?.competition !== window.competitionId ||
        (item?.classification?.competition === window.competitionId &&
          item?.classification?.phase !== window.currentPhase))
    );
  }, [item, enableCompetitionLink]);

  const clicableText = useMemo(
    () => (isDesktop ? { onClick: handleClick, role: 'button' } : {}),
    [isDesktop, handleClick],
  );

  return (
    <li
      className={clsx({
        [styles.step]: true,
        [styles.selected]: selected,
        [`phase-${item?.classification?.phase}`]: item?.classification?.phase,
      })}
      style={{
        width: itemWidth,
      }}
    >
      <div className={styles.stepBtnWrapper}>
        <button type='button' className={clsx(styles.stepBtn)} onClick={handleClick}>
          {!item?.hashtags && <img src={item?.mainMedia?.image?.square.s2} alt={item?.title} />}
          {item?.hashtags?.length > 0 && <PkIcon name={item.hashtags[0]} />}
        </button>
      </div>

      {item?.htmlDescription && (
        <div className={clsx(styles.stepLabel)} {...clicableText}>
          {parseHtmlToReact(item.htmlDescription ?? '')}
        </div>
      )}
      <div className={clsx(styles.stepDetails)}>
        {item?.title && (
          <div className={clsx(styles.stepTitle)} {...clicableText}>
            {item.title}
          </div>
        )}
        {item?.body && (
          <div className={clsx(styles.stepDescr)}>
            {item.body
              .filter((o) => o._type === 'PARAGRAPH')
              .map((p, i) => (
                <p key={`item_${i}`}>{stripHtml(p._html)}</p>
              ))}
            {enableBottomLink && selected && (
              <PkButton appearance='text' linkHref={getCompetitionLink()} linkTarget='_self' type='button'>
                {t('go-to-competition')}
                <PkIcon name='navigation-chevron-right' className='pk-ml--8' role='img' />
              </PkButton>
            )}
          </div>
        )}
      </div>
    </li>
  );
};

export default memo(Item);
